import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { Token } from 'src/app/core/types/auth/token';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {

  readonly TOKEN_KEY:string = environment.tokenKey;

  public token!:Token;

  constructor(private service:AuthService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem(this.TOKEN_KEY) as string);
  }

  logout(){
    this.service.logout();
  }
}
